import React, { useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import { useState } from "react";
import { Heart } from "./Heart";
import { HeartFull } from "./HeartFull";

export function LikeButton({
  className,
  onRated,
  animate = true,
  liked: controlledLiked,
  triggerAnimation = false,
  disabled = false,
}) {
  const [localLiked, setLocalLiked] = useState(false);
  const [flying, setFlying] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false); // добавляем состояние анимации

  const isLiked = controlledLiked !== undefined ? controlledLiked : localLiked;
  const setIsLiked = controlledLiked !== undefined ? () => {} : setLocalLiked;

  // Эффект для внешней анимации
  useEffect(() => {
    if (triggerAnimation) {
      setIsAnimating(true);
      setFlying(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
        setFlying(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [triggerAnimation]);

  const handleClick = async () => {
    if (disabled) return;

    // Запускаем анимацию кнопки
    setIsAnimating(true);

    if (animate) {
      // Режим с анимацией
      setFlying(false);
      setIsLiked(false);

      setTimeout(() => {
        setIsLiked(true);
        setFlying(true);
      }, 10);

      try {
        await onRated();
      } finally {
        setTimeout(() => {
          setIsLiked(false);
          setFlying(false);
          // setIsAnimating(false);
        }, 500);
      }
    } else {
      // Режим без анимации - просто toggle
      const newLiked = !isLiked;
      setIsLiked(newLiked);
      await onRated(newLiked);

      // Завершаем анимацию через 300ms
      setTimeout(() => setIsAnimating(false), 300);
    }
  };

  if (disabled) {
    // ... disabled версия
  }

  return (
    <div
      className={`${className} tbk-relative tbk-flex tbk-flex-col tbk-items-center`}
    >
      {flying && ( // теперь flying всегда используется
        <div
          // key={Date.now()}
          className="tbk-absolute tbk-bottom-8 tbk-animate-heartFly"
        >
          <HeartFull className="tbk-h-6 tbk-w-6 tbk-text-coral" />
        </div>
      )}

      <button
        onClick={handleClick}
        className={`tbk-group tbk-flex tbk-flex-col tbk-items-center ${
          isAnimating ? "tbk-animate-buttonScale" : ""
        }`}
        disabled={disabled}
      >
        <div
          className={`tbk-rounded-full tbk-border-2 tbk-p-2.5 tbk-transition-all tbk-duration-200 ${
            isLiked
              ? "tbk-border-coral tbk-bg-coral-light"
              : "tbk-group-hover:tbk-border-coral tbk-group-hover:tbk-bg-coral-light/10 tbk-border-blue-grey-light"
          }`}
        >
          <Heart
            className={`tbk-h-5 tbk-w-5 tbk-transition-all tbk-duration-200 ${
              isLiked
                ? "tbk-text-basic-white"
                : "tbk-group-hover:tbk-text-coral tbk-text-blue-grey"
            }`}
          />
        </div>
        <span
          className={`tbk-text-small tbk-mt-1 ${
            isLiked ? "tbk-text-coral" : "tbk-text-blue-grey"
          } tbk-group-hover:tbk-text-coral`}
        >
          {isLiked ? "Loved it!" : "Loved it"}
        </span>
      </button>
    </div>
  );
}
